module.exports = __webpack_public_path__ + "img/bergdorf.a3c2e96.svg";